import { Typography } from "@material-ui/core";
import Chip from "@material-ui/core/Chip";
import IconButton from "@material-ui/core/IconButton";
import { makeStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import InfoIcon from "@material-ui/icons/Info";
import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { authStoreContext } from "../../core/mainStore";

const useStyles = makeStyles({
  noMaxWidth: {
    maxWidth: "none"
  },
  siteMargin: {
    marginRight: 8
  }
});

const VersionField = (props: { label: string; value: string }) => {
  const { label, value } = props;
  return (
    <div
      style={{ display: "grid", gridTemplateRows: "auto auto", minWidth: 140 }}
    >
      <Typography style={{ opacity: 0.7 }} variant={"caption"}>
        {label}
      </Typography>
      <Typography>{value}</Typography>
    </div>
  );
};

export const AppVersion = observer(({ apiVersion }: any) => {
  const classes = useStyles();
  const auth = useContext(authStoreContext);

  const guiVersion = process.env.REACT_APP_VERSION;

  const i18n = useTranslation();
  const guiVersionTitle = i18n.t("lego:header.guiVersion", "GUI VERSION");
  const apiVersionTitle = i18n.t("lego:header.apiVersion", "API VERSION");

  const ShowVersion = () => (
    <>
      <VersionField label={guiVersionTitle} value={guiVersion || "-"} />
      <VersionField
        label={apiVersionTitle}
        value={apiVersion.tagName || "-"}
      />
    </>
  );

  return (
    <>
      {auth.isAdmin() && (
        <>
          {apiVersion?.site && (
            <Chip
              className={classes.siteMargin}
              label={apiVersion.site}
              color={"secondary"}
              variant={"outlined"}
              size={"small"}
            />
          )}
          <Tooltip
            classes={{ tooltip: classes.noMaxWidth }}
            title={ShowVersion()}
          >
            <IconButton color={"inherit"} aria-label="app-version">
              <InfoIcon />
            </IconButton>
          </Tooltip>
        </>
      )}
    </>
  );
});
